import { Breadcrumb } from "@novaescola/eva-react-v2/lib/Breadcrumb";
import { Link } from "@novaescola/eva-react-v2/lib/Link";
import * as React from "react";
import { Helmet } from "react-helmet";
import { isContentActivity, isContentSchoolProjects, isContentRecomposition } from "../../data/utils";


const ContentBreadcrumb = ({ data }) => {
  const isRecomposition = isContentRecomposition(data.content.categories);
  const isActivity = isContentActivity(data.content.categories);
  const isGoodPractices = isContentSchoolProjects(data.content.categories);
  const etapas = data.content.categories.filter(
    (category) => category.category === "ETAPAS"
  );

  const mappedLinksBreadcrumb = {
    "Educação Infantil": "https://novaescola.org.br/tag/1158/educacao-infantil",
    "Fundamental 1": "https://novaescola.org.br/tag/1555/ensino-fundamental-1",
    "Fundamental 2": "https://novaescola.org.br/tag/1556/ensino-fundamental-2",
    "Ensino Médio": "https://novaescola.org.br/tag/1389/ensino-medio",
    "Anos Finais do Fundamental":
      "https://novaescola.org.br/tag/1556/ensino-fundamental-2",
    "Anos Iniciais do Fundamental":
      "https://novaescola.org.br/tag/1555/ensino-fundamental-1",
    "Educação de Jovens e Adultos":
      "https://novaescola.org.br/tag/1329/educacao-de-jovens-e-adultos",
  };

  const breadcrumb = [
    {
      name: "Início",
      url: "https://novaescola.org.br",
      event: "SITE: Click - Nova página de conteúdo - breadcrumb início/home",
    },
    {
      name: "Jornalismo",
      url: "https://novaescola.org.br/subhome/176/jornalismo",
      event: "SITE: Click - Nova página de conteúdo - breadcrumb jornalismo",
    },
  ];

  if (isRecomposition) {
    breadcrumb.splice(1, 1);

    breadcrumb.push(
      {
        name: "Planos de aula",
        url: "https://novaescola.org.br/planos-de-aula",
        event: "SITE: Click - Nova página de conteúdo - breadcrumb PANE",
      },
      {
        name: "Fichas de recomposição",
        url: "https://novaescola.org.br/fichas-de-recomposicao-de-aprendizagem",
        event: "SITE: Click - Nova página de conteúdo - breadcrumb fichas",
      }
    );
  } else if (isActivity) {
    breadcrumb.splice(1, 1);

    breadcrumb.push(
      {
        name: "Planos de aula",
        url: "https://novaescola.org.br/planos-de-aula",
        event: "SITE: Click - Nova página de conteúdo - breadcrumb PANE",
      },
      {
        name: "Banco de atividades",
        url: "https://novaescola.org.br/atividades/alfabetizacao",
        event: "SITE: Click - Nova página de conteúdo - breadcrumb atividades",
      }
    );
  }else if (isGoodPractices) {
    breadcrumb.splice(1, 1);
    breadcrumb.push(
      {
        name: "Projetos escolares",
        url: "https://novaescola.org.br/projetos-escolares",
        event: "SITE: Click - Nova página de conteúdo - breadcrumb projetos escolares",
      }
    );
  } else if (!etapas || etapas.length > 1) {
    breadcrumb.push({
      name: "Todas as etapas de ensino",
      url: "https://novaescola.org.br/etapas-de-ensino/todas-as-etapas",
      event: "SITE: Click - Nova página de conteúdo - breadcrumb etapa",
    });
  } else if (etapas && Array.isArray(etapas) && etapas.length) {
    const etapa = etapas[0].name;

    const mappedLinkMatch = mappedLinksBreadcrumb[etapa];

    if (!mappedLinkMatch) {
      breadcrumb.push({
        name: "Todas as etapas de ensino",
        url: "https://novaescola.org.br/etapas-de-ensino/todas-as-etapas",
        event: "SITE: Click - Nova página de conteúdo - breadcrumb etapa",
      });
    } else {
      breadcrumb.push({
        name: etapa,
        url: mappedLinkMatch,
        event: "SITE: Click - Nova página de conteúdo - breadcrumb etapa",
      });
    }
  }

  const breadcrumbListSchema = breadcrumb.map((item, index) => {
    return {
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@id": item.url,
        name: item.name,
      },
    };
  });

  return (
    <>
      <Breadcrumb.Root>
        <Breadcrumb.List color="black"> 
          {breadcrumb.map((item, index) => (
            <Breadcrumb.Item key={item.name}>
              <Link href={item.url} data-track={item.event}>
                {item.name}
              </Link>
              { index + 1 !== breadcrumb.length && <Breadcrumb.Separator /> }
            </Breadcrumb.Item>
          ))}
        </Breadcrumb.List>
      </Breadcrumb.Root>

      <Helmet>
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": ${JSON.stringify(breadcrumbListSchema, null, 2)}
        }`}
        </script>
      </Helmet>
    </>
  );
};

export default ContentBreadcrumb;
